// TSS vite/06 — dp versioning scheme. Newest entry first.
// Type enum: 'feature' | 'fix' | 'improvement' | 'breaking'.

const CHANGELOG = [
    {
        version: 'dp0.1',
        date: '2026-10-14',
        title: 'Sitio web inicial de Total Medios',
        notes: [
            { type: 'feature',     text: 'Landing con secciones de servicios, proceso, soluciones, nosotros, preguntas frecuentes y contacto' },
            { type: 'feature',     text: 'Formulario de contacto con selección de servicio y consentimiento de tratamiento de datos' },
            { type: 'feature',     text: 'Página de política de tratamiento de datos personales (Ley 1581 de 2012)' },
            { type: 'improvement', text: 'Prerenderizado estático por ruta, metadatos SEO, datos estructurados y sitemap' },
            { type: 'improvement', text: 'Imágenes responsive en AVIF y WebP con carga diferida' },
        ],
    },
];

export default CHANGELOG;
